import { Component } from '@angular/core';
import { DialogControllerService } from '../../services/dialog-controller/dialog-controller.service';
import { BaseViewComponent } from '../base-view/base-view.component';
import { DialogIdentifier } from '../../services/dialog-identifier';
import { NotificationService } from '../../services/notification/notification.service';
import { ProfileStoreService } from '../../services/profile-store/profile-store.service';

@Component({
  selector: 'baf-user-profile-view',
  templateUrl: './user-profile-view.component.html',
  styleUrls: ['./user-profile-view.component.css']
})
export class UserProfileViewComponent extends BaseViewComponent {
  constructor(
    dialogController: DialogControllerService,
    private profileStore: ProfileStoreService,
    private notifier: NotificationService
  ) {
    super(DialogIdentifier.UserProfileView, dialogController);
  }

  deleteValue() {
    // TODO Dostosować do obsługi różnych atrybutów.
    this.profileStore.storeSelectionStats('STATYSTYKI_WYBORU', null).subscribe(result => {
      this.notifier.success('Informacje zostały usunięte');
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user-profile-view/user-profile-view.component.ts